module.exports = {"yytx22":{"daobanList":[{"title":"1:房屋租赁登记备案","values":[{"name":"是","xuanzhong":1,"cailiaoList":[{"name":"1、变更房屋租赁合同申请表","state":"必要"},{"name":"2、双方当事人身份证明","state":"必要"},{"name":"3、原《房屋租赁登记备案证明》","state":"非必要"},{"name":"4、《房屋租赁变更登记备案申请书》","state":"必要"}]},{"name":"否","xuanzhong":1,"cailiaoList":[{}]}]}]}}


//////////////////
// WEBPACK FOOTER
// ./static/js/situation/yytx22.json
// module id = 1320
// module chunks = 0